import React from 'react';
import EntityPickerOverlay from './EntityPickerOverlay';

const WorkspacePickerOverlay = ({ open, config, parentRow, onSubmit, onClose, colors }) => {
  if (!open || !config) return null;

  return (
    <EntityPickerOverlay
      pickerConfig={config}
      parentRowData={parentRow}
      colors={colors}
      onSubmit={onSubmit}
      onClose={onClose}
    />
  );
};

export default WorkspacePickerOverlay;
